'use strict';

angular.module('risevision.editor.services', [
  'risevision.common.config',
  'risevision.common.header',
  'risevision.common.gapi'
]);
